import React from 'react';
import { style } from 'glamor';
import Button from './ButtonTemplate';
import { SECONDARY } from 'style/colors';

let danger = style({
  color: SECONDARY,
  border: `1px solid ${SECONDARY}`,
  ':hover:not([disabled])': {
    color: 'white',
    backgroundColor: SECONDARY,
    border: `1px solid ${SECONDARY}`,
  }
});

let DangerButton = ({ children, customDataTestID, ...props }) => (
  <Button customDataTestID={customDataTestID} className={`${danger} danger`} {...props}>{children}</Button>
);

export default DangerButton;
